import React, { Component } from "react";
import { Map, Marker, GoogleApiWrapper } from "google-maps-react";
import InfoWindowEx from "./InfoWindowEx";
// import axios from "axios";
import styled from "styled-components";
import { colors } from "../resources/ThemeColors";
import renderIf from "render-if";

const InfoContentDiv = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;

const Button = styled.button`
  height: 2.5em;
  width: 8em;
  color: ${(props) => (props.main ? "white" : "#9C27B0")};
  font-weight: 600;
  background-color: ${(props) => (props.main ? "#9C27B0" : "white")};
  margin-right: 1em;
  border: 1px solid #9c27b0;
  border-radius: 4px;
  cursor: pointer;
  :focus {
    outline: none;
  }
`;

const Links = styled.a`
  text-decoration: none;
  color: ${colors.main};
`;

let API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

class MapContainer extends Component {
  state = {
    currentUserLocation: {},
    bounds: null,
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},
    data: [],
    userSearchLocation: {},
    salons: [],
    position: {},
  };

  static getDerivedStateFromProps(props, state) {
    if (props.salons !== state.salons) {
      return {
        salons: props.salons,
        position: props.mapLocation,
        // otherSalons: ResultsSection.getSalonProximity(
        //   props.salons,
        //   props.mapQueryPosition
        // ),
      };
    }
    // No state update necessary
    return null;
  }

  onMarkerClick = (props, marker, e) => {
    this.setState({
      selectedPlace: props.place_,
      activeMarker: marker,
      showingInfoWindow: true,
    });
  };

  render() {
    console.log("map-position", this.props.mapLocation);
    return (
      <Map
        google={this.props.google}
        style={{ width: "100%", margin: "auto" }}
        className={"map"}
        zoom={13}
        initialCenter={this.state.position}
        loading={false}
      >
        {this.state.salons.map((salon) => (
          <Marker
            position={{ lat: salon.latitude, lng: salon.longitude }}
            onClick={this.onMarkerClick}
            onMouseover={this.onMouseoverMarker}
            place_={{ name: salon.name, id: salon.id }}
            color="blue"
          />
        ))}
        <InfoWindowEx
          marker={this.state.activeMarker}
          visible={this.state.showingInfoWindow}
        >
          <InfoContentDiv>
            <h3>{this.state.selectedPlace.name}</h3>
            {renderIf(this.state.selectedPlace.id !== null)(
              <Links
                href={`/bookings/${this.state.selectedPlace.id}/${this.state.selectedPlace.name}`}
              >
                <Button type="button" main>
                  Book
                </Button>
              </Links>
            )}
          </InfoContentDiv>
        </InfoWindowEx>
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: API_KEY,
})(MapContainer);
